// Email service using FormSubmit - works for both localhost and esnresearch.in
export const sendEmail = async (emailData) => {
  try {
    const formData = new FormData();
    
    // Add form data
    formData.append('name', emailData.from_name || 'ESN Publications Website');
    formData.append('email', emailData.reply_to || 'cotactus@esnresearch.in');
    formData.append('subject', emailData.subject);
    formData.append('message', emailData.html || emailData.message);
    
    // FormSubmit configuration
    formData.append('_next', window.location.origin + '/thank-you'); // Redirect to thank you page
    formData.append('_captcha', 'false'); // Disable captcha
    formData.append('_template', 'table'); // Use table template
    formData.append('_autoresponse', 'Thank you for contacting ESN Publications. We will get back to you within 24 hours.');
    
    const response = await fetch('https://formsubmit.co/contactus@esnresearch.in', {
      method: 'POST',
      body: formData
    });
    
    if (response.ok) {
      return { success: true };
    } else {
      throw new Error('Failed to send email');
    }
  } catch (error) {
    console.error('Email sending failed:', error);
    throw error;
  }
};

// Alternative email service for contact forms
export const sendContactEmail = async (formData) => {
  try {
    const data = new FormData();
    
    // Add all form fields
    Object.keys(formData).forEach(key => {
      data.append(key, formData[key]);
    });
    
    // FormSubmit configuration
    data.append('_next', window.location.origin + '/contact?success=true');
    data.append('_captcha', 'false');
    data.append('_template', 'table');
    data.append('_autoresponse', 'Thank you for contacting ESN Publications. We have received your message and will respond within 24 hours.');
    
    const response = await fetch('https://formsubmit.co/contactus@esnresearch.in', {
      method: 'POST',
      body: data
    });
    
    return { success: response.ok };
  } catch (error) {
    console.error('Contact form submission failed:', error);
    return { success: false, error: error.message };
  }
};